export default "__VITE_ASSET__c8cad9dc__"